import React, { createContext, useCallback, useContext, useState } from 'react';
import SupportDialog from '../components/custom/SupportDialog';
import { CustomAlert } from '../components/shared';

interface IDrawerContext {
    isDrawerOpen: boolean;
    drawerOptions: IDrawerOptions[];
    toggleDrawerOpen: () => void;
    setDrawerOptions: (newDrawerOptions: IDrawerOptions[]) => void;
    // --- NOVAS PROPRIEDADES ---
    openSupportDialog: () => void;
}

interface IDrawerOptions {
    icons: string;
    path: string;
    label: string;
}

interface IDrawerProviderProps {
    children: React.ReactNode
}

const DrawerContext = createContext({} as IDrawerContext);

export const UseDrawerContext = () => {
    return useContext(DrawerContext);
};

export const DrawerProvider: React.FC<IDrawerProviderProps> = ({ children }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerOptions, setDrawerOptions] = useState<IDrawerOptions[]>([]);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    
    
    const [isSupportDialogOpen, setIsSupportDialogOpen] = useState(false);

    const toggleDrawerOpen = useCallback(() => {
        setIsDrawerOpen(oldDrawerOpen => !oldDrawerOpen);
    }, []);

    const handleSetDrawerOptions = useCallback((newDrawerOptions: IDrawerOptions[]) => {
        setDrawerOptions(newDrawerOptions);
    }, []);

    const openSupportDialog = useCallback(() => {
        setIsSupportDialogOpen(true);
    }, []);

    const closeSupportDialog = useCallback(() => {
        setIsSupportDialogOpen(false);
    }, []);


    return (
        <DrawerContext.Provider value={{ isDrawerOpen, drawerOptions, toggleDrawerOpen, setDrawerOptions: handleSetDrawerOptions, openSupportDialog }}>
            {children}
            
            <SupportDialog
                open={isSupportDialogOpen}
                close={closeSupportDialog}
                invalid={() => setAlertInfo({ open: true, message: 'Preencha todos os campos!', severity: 'warning' })}
                error={() => setAlertInfo({ open: true, message: 'Erro ao criar suporte!', severity: 'error' })}
                create={() => setAlertInfo({ open: true, message: 'Suporte criado com sucesso!', severity: 'success' })}
            />
            {alertInfo.open &&
                <CustomAlert
                    key={alertInfo.message}
                    severity={alertInfo.severity}
                    message={alertInfo.message}
                />
            }
        </DrawerContext.Provider>
    );
};